import { render, staticRenderFns } from "./SpcRuleManager.vue?vue&type=template&id=862be23c&"
import script from "./SpcRuleManager.js?vue&type=script&lang=js&"
export * from "./SpcRuleManager.js?vue&type=script&lang=js&"
import style0 from "./SpcRuleManager.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports